/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesExportTypeFilters.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Export Type Filter Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Tuesday, December 10, 2019 - 09:25:27 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      12/10/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const ExportTypeFilterList = Loadable({
    loader: () => import('../containers/ExportTypeFilters/ExportTypeFilterListContainer'),
    loading: Loading,
});

export const ExportTypeFilterForm = Loadable({
    loader: () => import('../containers/ExportTypeFilters/ExportTypeFilterEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesExportTypeFilters.js